import { createFileRoute } from '@tanstack/react-router';
import { AppearanceSettingsPage } from '../components/settings/settings-shell.js';

export const Route = createFileRoute('/$workspaceSlug/settings/appearance')({
  component: AppearanceSettingsPage,
});
